import { t } from '@lingui/core/macro'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'
import { useSelector, useDispatch } from 'react-redux'
import * as TemplateActions from '../template.actions'

export const EncodingOptions = () => {
  const dispatch = useDispatch()

  const linkField = useSelector(state =>
    Object.values(state.Template.templateFieldsById).find(
      tf => tf.governance_type === 'link' || tf.field.governance_type === 'link',
    ),
  )

  const { do_not_encode_manually_entered_parameters } = linkField.field.link_governance
  const { use_redirect_url } = linkField.field.link_governance

  return (
    <>
      <div>
        <FormControlLabel
          control={
            <Checkbox
              checked={do_not_encode_manually_entered_parameters}
              onChange={(e, newVal) => {
                const newTf = {
                  ...linkField,
                  field: {
                    ...linkField.field,
                    link_governance: {
                      ...linkField.field.link_governance,
                      do_not_encode_manually_entered_parameters: newVal,
                    },
                  },
                }
                // console.log(linkField, newTf)
                dispatch(TemplateActions.updateTemplateField(newTf))
              }}
              value={do_not_encode_manually_entered_parameters}
              style={{ padding: 2 }}
              color="secondary"
            />
          }
          label={t`Do not encode manually entered parameters`}
        />
      </div>
      <div>
        <FormControlLabel
          control={
            <Checkbox
              checked={use_redirect_url}
              onChange={(e, newVal) => {
                const newTf = {
                  ...linkField,
                  field: {
                    ...linkField.field,
                    link_governance: {
                      ...linkField.field.link_governance,
                      use_redirect_url: newVal,
                    },
                  },
                }
                dispatch(TemplateActions.updateTemplateField(newTf))
              }}
              value={use_redirect_url}
              style={{ padding: 2 }}
              color="secondary"
            />
          }
          label={t`Add parameters to redirect URL`}
        />
        <Typography variant="caption">
          {t`Enabling this option requires the url entered by the user to have the redirect url immediatly follow the first ? in the url.`}
        </Typography>
      </div>
    </>
  )
}
